<h1 mat-dialog-title>Import Optionen</h1>
<div mat-dialog-content>
    <mat-form-field style="width: 100%">
        <mat-label>Einstalldatum</mat-label>
        <input matInput [matDatepicker]="picker" [formControl]="einstalldatumCtrl" [readonly]="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field style="width: 100%; margin-bottom: 24px">
        <mat-label>KFZ-Kennzeichen</mat-label>
        <input matInput [formControl]="kfzCtrl" />
        <mat-hint>KFZ Kennzeichen des Transportfahrzeugs</mat-hint>
    </mat-form-field>
    <mat-divider></mat-divider>
    <ng-container *ngIf="!istDerselbeKunde()">
        <p>Sollen die Tiere in HI-Tier als Zugang gemeldet werden?</p>
        <div style="width: 100%; margin-bottom: 24px">
            <mat-radio-group aria-label="Abgang an HIT melden ja oder nein" [formControl]="hitMeldenCtrl">
                <mat-radio-button [value]="0">nein</mat-radio-button>
                <mat-radio-button [value]="1">ja</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-divider></mat-divider>

        <p>Herkunftsbetrieb ausw&auml;hlen, der f&uuml;r alle Tiere dieser Liste hinterlegt werden soll. (optional)</p>
        <span *ngIf="tierliste?.haendler_uebernehmen > 0" class="info-box"
            >Der Ersteller der Tierliste ({{ tierliste.kunde_abgang }} ) hat angegeben, dass die H&auml;ndler der
            einzelnen Tiere mit &uuml;bergeben werden. Wenn hier ein anderer H&auml;ndler ausgew&auml;hlt wird, werden
            diese &uuml;berschrieben.</span
        >

        <!-- Händler-Auswahl -->
        <div style="margin-bottom: 16px" *ngIf="!selectedBetriebskontakt">
            <div style="display: flex; justify-content: space-around; align-items: center; width: 100%">
                <kiene-haendler-selector
                    #haendlerSelector
                    [formControl]="haendlerCtrl"
                    [disabled]="hitMeldenCtrl.value === 0"
                    style="width: 90%"
                >
                </kiene-haendler-selector>
                <button
                    *kienePermission="[9132]"
                    (click)="openHaendlerVerwaltung()"
                    mat-icon-button
                    color="accent"
                    [disabled]="hitMeldenCtrl.value === 0"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>

        <!-- "Oder" Text -->
        <div
            *ngIf="!selectedBetriebskontakt && (!haendlerCtrl.value || !haendlerCtrl.value.viehhaendler_id)"
            style="text-align: center; margin: 16px 0; color: #666; font-weight: 500"
        >
            Oder
        </div>

        <!-- Betriebskontakt-Auswahl -->
        <div style="margin-bottom: 16px" *kienePermission="[9601]">
            <!-- Auswahl-Dialog (nur anzeigen wenn kein Kontakt ausgewählt und kein Händler ausgewählt) -->
            <div *ngIf="!selectedBetriebskontakt && (!haendlerCtrl.value || !haendlerCtrl.value.viehhaendler_id)">
                <kiene-betriebskontakt-auswahl
                    [config]="{
                        showHaendler: true,
                        showLandwirte: true,
                        showSchlachthoefe: true,
                        showAll: true,
                        multiSelect: false,
                        compact: true,
                        title: '',
                        placeholder: 'Kontakt auswählen...',
                        allowCreateNew: true,
                        keepOpenOnSelect: false
                    }"
                    [selectedKontakte]="[]"
                    [disabled]="hitMeldenCtrl.value === 0"
                    (kontaktSelected)="onBetriebskontaktSelected($event)"
                ></kiene-betriebskontakt-auswahl>
            </div>

            <!-- Anzeige der ausgewählten Händler-Card -->
            <div *ngIf="selectedBetriebskontakt" style="margin-top: 16px">
                <kiene-betriebskontakt-card
                    [kontakt]="selectedBetriebskontakt"
                    [config]="{
                        showActions: true,
                        showMenu: false,
                        showFavorit: false,
                        showBadge: true,
                        compact: false,
                        selectedMode: true
                    }"
                    (entfernen)="onBetriebskontaktEntfernen()"
                >
                </kiene-betriebskontakt-card>
            </div>
        </div>
    </ng-container>

    <mat-divider style="margin: 16px 0"></mat-divider>
    <ng-container *ngIf="canLoadReklamationen">
        <p>Sollen die Tiere ihre vorhandenen Reklamationen behalten?</p>
        <div style="width: 100%; margin-bottom: 24px">
            <mat-radio-group
                aria-label="Reklamationen behalten ja oder nein"
                [formControl]="reklamationenUebernehmenCtrl"
            >
                <mat-radio-button [value]="0">nein</mat-radio-button>
                <mat-radio-button [value]="1">ja</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-divider></mat-divider>
    </ng-container>
    <div class="gewicht-section">
        <h5>Gewicht (optional)</h5>
        <button
            *ngIf="selectedTiere?.length > 0 && canLoadTransferWeight"
            mat-stroked-button
            color="accent"
            (click)="alteGewichteUebernehmen()"
            class="gewicht-action-button"
        >
            Letztes Gewicht laden
        </button>
        <mat-radio-group [formControl]="gewichtModusCtrl" class="gewicht-mode-group">
            <mat-radio-button value="single" (click)="toggleGewichtModus('single')">
                Gewicht pro Tier eingeben
            </mat-radio-button>
            <mat-radio-button value="all" (click)="toggleGewichtModus('all')">durchschnittlichestiergewicht</mat-radio-button>
            <mat-radio-button value="total" (click)="toggleGewichtModus('total')">
                Gesamtgewicht aller Tiere
            </mat-radio-button>
        </mat-radio-group>

        <ng-container *ngIf="selectedTiere?.length > 0">
            <ng-container *ngIf="gewichtModusCtrl.value === 'single'">
                <div class="tier-gewicht-list">
                    <div *ngFor="let tier of selectedTiere" class="tier-gewicht-row">
                        <mat-form-field style="width: 100%">
                            <mat-label>{{ tier.ohrmarke_notnull || ("Tier " + tier.gt_id) }}</mat-label>
                            <input [formControl]="tier.gewichtCtrl" inputmode="decimal" matInput type="number" />
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="gewichtModusCtrl.value === 'all'">
                <p class="mat-caption">Dieses Gewicht wird fuer {{ selectedTiereCount }} Tier(e) uebernommen.</p>
                <mat-form-field style="width: 100%">
                    <mat-label>Gewicht je Tier (fuer alle Tiere)</mat-label>
                    <input [formControl]="gewichtAlleSelektiertCtrl" inputmode="decimal" matInput type="number" />
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="gewichtModusCtrl.value === 'total'">
                <p class="mat-caption">
                    Dieses Gesamtgewicht wird fuer alle {{ selectedTiereCount }} Tier(e) gespeichert.
                </p>
                <mat-form-field style="width: 100%">
                    <mat-label>Gesamtgewicht aller Tiere</mat-label>
                    <input [formControl]="gewichtGesamtCtrl" inputmode="decimal" matInput type="number" />
                </mat-form-field>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!selectedTiere?.length">
            <ng-container *ngIf="gewichtModusCtrl.value !== 'total'">
                <mat-form-field style="width: 100%">
                    <mat-label>Einstallgewicht je Tier</mat-label>
                    <input [formControl]="gewichtAlleSelektiertCtrl" inputmode="decimal" matInput type="number" />
                </mat-form-field>
                <p class="mat-caption">
                    Tierdetails konnten nicht geladen werden. Sie koennen ein einheitliches Einstallgewicht je Tier
                    erfassen.
                </p>
            </ng-container>
            <ng-container *ngIf="gewichtModusCtrl.value === 'total'">
                <mat-form-field style="width: 100%">
                    <mat-label>Gesamtgewicht aller Tiere</mat-label>
                    <input [formControl]="gewichtGesamtCtrl" inputmode="decimal" matInput type="number" />
                </mat-form-field>
            </ng-container>
        </ng-container>

        <p *ngIf="selectedTiereTotalGewicht !== null">
            Gesamtgewicht: <strong>{{ selectedTiereTotalGewicht }}</strong> kg
        </p>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()">Speichern</button>
</div>
